// apps/merchant-v3/src/store/user.ts
//
// Phase 6 Wave 1 Task 02 — Zustand stub store for current user shape.
// Phase 6 Wave 1 Task 03 — Wired into AuthProvider; `setUser` mirrors
// `useMe()` server-truth, `clear()` is invoked by logout. Read this
// store only in places that absolutely cannot use `useAuth()` (e.g.
// non-React utilities like `useCanMutate`); pages should prefer the
// React Query cache via `useMe()`.
//
// vg-binding: PLAN:task-02
// vg-binding: PLAN:task-03
// vg-binding: P6.D-02
// vg-binding: P6.D-05
// vg-binding: P6.D-246
// vg-binding: P6.D-248

import { create } from 'zustand';

import type { User } from '@/types/user';

export interface UserStore {
  user: User | null;
  setUser: (u: User | null) => void;
  /** Reset to logged-out shape — invoked by AuthProvider.logout(). */
  clear: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (u) => set({ user: u }),
  clear: () => set({ user: null }),
}));

/**
 * Convenience selector — read the current user object.
 * Components that only need the user object should use this hook
 * to keep re-render scope minimal.
 */
export function useUser(): User | null {
  return useUserStore((s) => s.user);
}
